// eslint-disable-next-line import/prefer-default-export
export const isObject = obj => obj && obj.constructor === Object;
